import { ConfigurationInterpreter, isPreciousColor, isGoldTemple, replaceFinish, TempleInfoMap } from '@lindberg/configuration'
import { FrameConfiguration } from './Frame'
import { GetUrl } from './Settings'

export { isPreciousColor, isGoldTemple, replaceFinish }

let TempleData: TempleInfoMap = {}

export async function GetTempleInfo() {
	const result = await fetch(GetUrl('temples.json'))
	TempleData = await result.json() as TempleInfoMap
}

export function ConfigurationIntepreter(config: FrameConfiguration): FrameConfiguration {
	return ConfigurationInterpreter(config, TempleData)
}
